<template>
  <div class="mod-config">
    <el-form :inline="true"
             :model="dataForm"
             @keyup.enter.native="getDataList()">
      <el-form-item>
        <el-input v-model="dataForm.key"
                  placeholder="请输入会员电话"
                  clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="getDataList()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="dataList"
              border
              v-loading="dataListLoading"
              @selection-change="selectionChangeHandle"
              style="width: 100%;">
      <el-table-column type="selection"
                       header-align="center"
                       align="center"
                       width="50">
      </el-table-column>
      <el-table-column prop="id"
                       header-align="center"
                       align="center"
                       label="id">
      </el-table-column>
      <el-table-column prop="lianxiren"
                       header-align="center"
                       align="center"
                       label="联系人">
      </el-table-column>
      <el-table-column prop="phone"
                       header-align="center"
                       align="center"
                       label="电话">
      </el-table-column>
      <el-table-column prop="gsname"
                       header-align="center"
                       align="center"
                       label="公司名称">
      </el-table-column>
      <el-table-column prop="gonghuoshangquyu"
                       header-align="center"
                       align="center"
                       label="供货商区域">
      </el-table-column>
      <el-table-column prop="jiaohuodi"
                       header-align="center"
                       align="center"
                       label="交货地">
      </el-table-column>
      <el-table-column prop="ishanshui"
                       header-align="center"
                       align="center"
                       label="是否含税">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.ishanshui===0"
                  type="error">含税</el-tag>
          <el-tag v-if="scope2.row.ishanshui===1"
                  type="success">不含税</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ishanyunfei"
                       header-align="center"
                       align="center"
                       label="是否含运费">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.ishanyunfei===0"
                  type="error">含运费</el-tag>
          <el-tag v-if="scope2.row.ishanyunfei===1"
                  type="success">不含运费</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="paytype"
                       header-align="center"
                       align="center"
                       label="付款方式">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.paytype===0"
                  type="error">协商</el-tag>
          <el-tag v-if="scope2.row.paytype===1"
                  type="success">有预付</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="yufubili"
                       header-align="center"
                       align="center"
                       label="预付款比例">
      </el-table-column>
      <el-table-column prop="jiaohuoshijian"
                       header-align="center"
                       align="center"
                       label="交货时间">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.jiaohuoshijian===0"
                  type="error">协商 </el-tag>
          <el-tag v-if="scope2.row.jiaohuoshijian!=0"
                  type="success">{{scope2.row.jiaohuoshijian}} </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="baojiajiezhishijian"
                       header-align="center"
                       align="center"
                       label="报价截止时间">
      </el-table-column>
      <el-table-column prop="isbaomi"
                       header-align="center"
                       align="center"
                       label="是否开启保密">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.isbaomi===0"
                  type="error">未开启 </el-tag>
          <el-tag v-if="scope2.row.isbaomi===1"
                  type="success">开启 </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status"
                       header-align="center"
                       align="center"
                       label="审核状态">
        <template slot-scope="scope2">
          <el-tag v-if="scope2.row.status===0"
                  type="error">未通过</el-tag>
          <el-tag v-if="scope2.row.status===1"
                  type="success">通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createtime"
                       header-align="center"
                       align="center"
                       label="创建时间">
      </el-table-column>
      <el-table-column fixed="right"
                       header-align="center"
                       align="center"
                       width="150"
                       label="操作">
        <template slot-scope="scope">
          <el-button type="text"
                     size="small"
                     @click="deleteHandle(scope.row.id)">删除</el-button>
          <el-button type="text"
                     size="small"
                     @click="lingjianguanli(scope.row.caigoucode)">零件管理</el-button>
          <el-button v-if="scope.row.status!=1"
                     type="text"
                     size="small"
                     @click="tongguo(scope.row)">审核通过</el-button>
          <el-button type="text"
                     size="small"
                     @click="jujue(scope.row)">拒绝</el-button>
          <el-button type="text"
                     size="small"
                     @click="baojia(scope.row.id)">报价管理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle"
                   @current-change="currentChangeHandle"
                   :current-page="pageIndex"
                   :page-sizes="[10, 20, 50, 100]"
                   :page-size="pageSize"
                   :total="totalPage"
                   layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible"
                   ref="addOrUpdate"
                   @refreshDataList="getDataList"></add-or-update>
    <!-- 展示零件开始              -->
    <el-dialog title="零件信息"
    width="90%"
               :visible.sync="showlingjianxinxi">
      <el-table :data="lingjianinfo"
                border
                v-loading="dataListLoading"
                style="width: 100%;">
        <el-table-column prop="name"
                         header-align="center"
                         align="center"
                         label="零件名称">
        </el-table-column>
        <el-table-column prop="count"
                         header-align="center"
                         align="center"
                         label="数量">
        </el-table-column>
        <el-table-column prop="danwei"
                         header-align="center"
                         align="center"
                         label="单位">
        </el-table-column>
        <el-table-column prop="cailiao"
                         header-align="center"
                         align="center"
                         label="材料">
        </el-table-column>
        <el-table-column prop="gongyi"
                         header-align="center"
                         align="center"
                         label="工艺">
        </el-table-column>
        <el-table-column prop="beizhu"
                         header-align="center"
                         align="center"
                         label="备注">
        </el-table-column>
        <el-table-column prop="tuzhi"
                         header-align="center"
                         align="center"
                         label="图纸1">
         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi)"
          />
        </template>   
        </el-table-column>
        <el-table-column prop="tuzhi2"
                         header-align="center"
                         align="center"
                         label="图纸2">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi2"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi2)"
          />
        </template>   
        </el-table-column>
        <el-table-column prop="tuzhi3"
                         header-align="center"
                         align="center"
                         label="图纸3">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi3"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi3)"
          />
        </template> 
        </el-table-column>
        <el-table-column prop="tuzhi4"
                         header-align="center"
                         align="center"
                         label="图纸4">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi4"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi4)"
          />
        </template>
        </el-table-column>
        <el-table-column prop="tuzhi5"
                         header-align="center"
                         align="center"
                         label="图纸5">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi5"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi5)"
          />
        </template>
        </el-table-column>
        <el-table-column prop="tuzhi6"
                         header-align="center"
                         align="center"
                         label="图纸6">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi6"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi6)"
          />
        </template>
        </el-table-column>
        <el-table-column prop="tuzhi7"
                         header-align="center"
                         align="center"
                         label="图纸7">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi7"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi7)"
          />
        </template>
        </el-table-column>
        <el-table-column prop="tuzhi8"
                         header-align="center"
                         align="center"
                         label="图纸8">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi8"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi8)"
          />
        </template>
        </el-table-column>
        <el-table-column prop="tuzhi9"
                         header-align="center"
                         align="center"
                         label="图纸9">
                         <template slot-scope="scope2">
          <img :src="scope2.row.tuzhi9"
               style="width: 200px; height: 200px; cursor: pointer;"
               @click="handlePreview(scope2.row.tuzhi9)"
          />
        </template>
        </el-table-column>
        <el-table-column prop="wenjian"
                         header-align="center"
                         align="center"
                         label="文件">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 展示零件结束              -->
    <!-- 展示报价信息开始 -->
    <el-dialog title="报价信息"
               width="80%"
               :close-on-click-modal="false"
               :visible.sync="showbaojia">
      <el-table :data="dataListbaojia"
                border
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
        <el-table-column prop="name"
                         header-align="center"
                         align="center"
                         label="名称">
        </el-table-column>
        <el-table-column prop="phone"
                         header-align="center"
                         align="center"
                         label="电话">
        </el-table-column>
        <el-table-column prop="addtime"
                         header-align="center"
                         align="center"
                         label="创建时间">
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 展示报价信息结束 -->
       <!-- 图片预览弹窗 -->
      <el-dialog
        :visible.sync="previewVisible"
        width="auto"
        center
        :show-close="true"
        title="图片预览"
        append-to-body
      >
        <img :src="previewImageUrl" style="max-width: 100%; max-height: 80vh; display: block; margin: 0 auto;" />
      </el-dialog>
  </div>
</template>

<script>
import AddOrUpdate from '@/components/jgcaigouinfo-add-or-update'
export default {
  data () {
    return {
      dataForm: {
        key: ''
      },
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataListSelections: [],
      addOrUpdateVisible: false,
      showlingjianxinxi: false,
      lingjianinfo: [],
      showbaojia: false,
      dataListbaojia: [],
      // 图片预览相关
      previewVisible: false,
      previewImageUrl: ''
    }
  },
  components: {
    AddOrUpdate
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    // 报价管理
    baojia (id) {
      console.log(id)
      this.$http({
        url: this.global.apiUrl + '/jisu/jjilu/list',
        method: 'get',
        params: {
          'caigouid': id,
          'key': this.dataForm.key
        }
      }).then((data) => {
        data = data.body.page.list
        console.log(data)
        if (data.length > 0) {
          console.log(data)
          this.showbaojia = true
          this.dataListbaojia = data
        } else {
          this.$message({
            message: '暂无报价',
            type: 'error',
            duration: 1500,
            onClose: () => {
            }
          })
        }
      })
    },
    // 审核不通过
    jujue (id) {
      console.log(id.status)
      id.status = 1
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgcaigouinfo/updatestatus',
        method: 'get',
        params: {
          'id': id.id,
          'status': 0
        }
      }).then((data) => {
        data = data.body
        if (data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        } else {
          this.$message({
            message: '操作失败',
            type: 'error',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        }
      })
    },
    // 审核通过
    tongguo (id) {
      console.log(id.status)
      id.status = 1
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgcaigouinfo/updatestatus',
        method: 'get',
        params: {
          'id': id.id,
          'status': 1
        }
      }).then((data) => {
        data = data.body
        if (data.code === 0) {
          this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        } else {
          this.$message({
            message: '操作失败',
            type: 'error',
            duration: 1500,
            onClose: () => {
              this.getDataList()
            }
          })
        }
      })
    },
    // 查看零件信息
    lingjianguanli (id) {
      this.showlingjianxinxi = true
      this.dataListLoading = true
      console.log(id)
      this.$http({
        url: this.global.apiUrl + '/jxjg/jglingjian/list',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'caigouid': id
        }
      }).then((data) => {
        data = data.body
        console.log(data)
        if (data && data.code === 0) {
          this.lingjianinfo = data.page.list
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 获取数据列表
    getDataList () {
      this.dataListLoading = true
      this.$http({
        url: this.global.apiUrl + '/jxjg/jgcaigouinfo/list',
        method: 'get',
        params: {
          'page': this.pageIndex,
          'limit': this.pageSize,
          'key': this.dataForm.key
        }
      }).then((data) => {
        data = data.body
        if (data && data.code === 0) {
          this.dataList = data.page.list
          this.totalPage = data.page.totalCount
        } else {
          this.dataList = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    },
    // 删除
    deleteHandle (id) {
      var ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.global.apiUrl + '/jxjg/jgcaigouinfo/delete',
          method: 'post',
          params: {
            'id': id
          }
        }).then((data) => {
          data = data.body
          if (data && data.code === 0) {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1500,
              onClose: () => {
                this.getDataList()
              }
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    // 图片预览方法
    handlePreview(url) {
      console.log("图片预览方法",url)
      this.previewImageUrl = url
      this.previewVisible = true
            console.log("图片预览方法",this.previewVisible)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/jgcaigouinfo.vue